export const elementTypeTranslate = (elementType) => {
  let returnType = ''
  switch (elementType) {
    case 'material': returnType = '자재'; break;
    case 'half': returnType = '반제품'; break;
    case 'product': returnType = '완제품'; break;
    default: break;
  }
  return returnType;
};